import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-be55c318"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "common-question-root-page main-scroll-topbar-content"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/qa_top_bg.png"
}, null, -1));

const _hoisted_3 = ["src"];
import { ref, onBeforeMount } from "vue";
import { getServerTime, date2ISO } from "../assets/utils/common.utils";
import TopNavigator from "../components/TopNavigator.vue";
import Footer from "../components/Footer.vue";
import dayjs from "dayjs";
import { Toast } from "vant";
export default {
  __name: 'CommonQuestion',
  props: {},

  setup(__props) {
    const props = __props;
    const questionImg = ref("");
    onBeforeMount(() => {
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      getServerTime().then(st => {
        const sTime = date2ISO(st);

        if (dayjs(sTime) < dayjs("2022-11-24T21:00:00+08:00")) {
          // console.log('早鸟阶段');
          questionImg.value = "https://summit-img.geekpark.net/if2023/common_qa_content_early_2.png";
        } else {
          // console.log('正常阶段');
          questionImg.value = "https://summit-img.geekpark.net/if2023/common_qa_content_normal_4.png";
        }

        Toast.clear();
      }).catch(() => {
        console.error;
        Toast.clear();
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "常见问题"
      }), _createElementVNode("div", _hoisted_1, [_hoisted_2, questionImg.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: questionImg.value
      }, null, 8, _hoisted_3)) : _createCommentVNode("", true), questionImg.value ? (_openBlock(), _createBlock(Footer, {
        key: 1
      })) : _createCommentVNode("", true)])], 64);
    };
  }

};